// FAQ-style accordion. Two patterns supported:
//   (1) <dl class="accordion"><dt>Q</dt><dd>A</dd>...</dl> — click dt toggles is-open on dt + dd
//   (2) .js-accordion-title + sibling content — click title toggles is-open on both
//
// SCSS handles transition: dd { max-height:0; overflow:hidden; transition:.3s }
//                          dd.is-open { max-height: 100rem }
export function initAccordion() {
  // Pattern 1: <dl class="accordion">
  document.querySelectorAll('dl.accordion').forEach((dl) => {
    dl.querySelectorAll('dt').forEach((dt) => {
      dt.addEventListener('click', () => {
        const dd = dt.nextElementSibling;
        if (!dd || dd.tagName !== 'DD') return;
        dt.classList.toggle('is-open');
        dd.classList.toggle('is-open');
      });
    });
  });

  // Pattern 2: .js-accordion-title
  document.querySelectorAll('.js-accordion-title').forEach((title) => {
    title.addEventListener('click', () => {
      title.classList.toggle('is-open');
      const content = title.nextElementSibling;
      if (content) content.classList.toggle('is-open');
    });
  });
}
